export default "__VITE_ASSET__BL8o3ktb__"